export const categoriesFieldProfile = [
  { name: 'first_name', label: 'Имя', type: 'text', disabled: false },
  { name: 'last_name', label: 'Фамилия', type: 'text', disabled: false },
  { name: 'patronymic', label: 'Отчество', type: 'text', disabled: false },
  { name: 'email', label: 'E-mail', type: 'email', disabled: false },
  { name: 'nickname', label: 'Уникальное имя', type: 'text', disabled: false },
  {
    name: 'UF_DEPARTMENT',
    label: 'Подразделение',
    type: 'text',
    disabled: false,
  },

  { name: 'phone', label: 'Телефон', type: 'tel', disabled: false },
];

export const categoriesFieldsOrg = [
  {
    label: 'Изображение',
    type: 'file',
    name: 'image',
    placeholder: 'Изображение',
    disabled: false,
  },
  {
    label: 'Наименование фирмы',
    type: 'text',
    name: 'name',
    placeholder: 'Наименование фирмы',
    disabled: false,
  },
  {
    label: 'Адрес',
    type: 'text',
    name: 'address',
    placeholder: 'Введите адрес',
    disabled: false,
  },
  {
    label: 'Телефон',
    type: 'tel',
    name: 'phone',
    placeholder: '+7(___) ___-__-__',
    disabled: false,
  },
  {
    label: 'ИНН',
    type: 'number',
    name: 'inn',
    placeholder: 'Введите ИНН',
    disabled: false,
  },
  {
    label: 'КПП',
    type: 'number',
    name: 'kpp',
    placeholder: 'Введите КПП',
    disabled: false,
  },
  {
    label: 'ОГРН',
    type: 'number',
    name: 'ogrn',
    placeholder: 'Введите ОГРН',
    disabled: false,
  },
  {
    label: 'БИК',
    type: 'number',
    name: 'bik',
    placeholder: 'Введите БИК',
    disabled: false,
  },
  {
    label: 'Расчетный счет',
    type: 'number',
    name: 'payment_account',
    placeholder: 'Введите номер счета',
    disabled: false,
  },
  {
    label: 'Банк',
    type: 'text',
    name: 'bank',
    placeholder: 'Введите название банка',
    disabled: false,
  },
  {
    label: 'Корр. счет',
    type: 'number',
    name: 'corresponding_account',
    placeholder: 'Введите номер счета',
    disabled: false,
  },
  {
    label: 'Идентификатор производства',
    type: 'text',
    name: 'external_id',
    placeholder: 'Введите id производства',
    disabled: false,
  },
  {
    label: 'Описание',
    type: 'textarea',
    name: 'description',
    placeholder: 'Введите описание организации',
    maxLength: 1000,
    disabled: false,
  },
];
export const categoriesFieldsMyOrg = [
  {
    label: 'Наименование фирмы',
    type: 'text',
    name: 'name',
    placeholder: 'Наименование фирмы',
    disabled: false,
  },
  {
    label: 'Адрес',
    type: 'text',
    name: 'address',
    placeholder: 'Введите адрес',
    disabled: false,
  },
  {
    label: 'Телефон',
    type: 'tel',
    name: 'phone',
    placeholder: '+7(___) ___-__-__',
    disabled: false,
  },
  {
    label: 'ИНН',
    type: 'number',
    name: 'inn',
    placeholder: 'Введите ИНН',
    disabled: false,
  },
  {
    label: 'КПП',
    type: 'number',
    name: 'kpp',
    placeholder: 'Введите КПП',
    disabled: false,
  },
  {
    label: 'ОГРН',
    type: 'number',
    name: 'ogrn',
    placeholder: 'Введите ОГРН',
    disabled: false,
  },
  {
    label: 'БИК',
    type: 'number',
    name: 'bik',
    placeholder: 'Введите БИК',
    disabled: false,
  },
  {
    label: 'Расчетный счет',
    type: 'number',
    name: 'payment_account',
    placeholder: 'Введите номер счета',
    disabled: false,
  },
  {
    label: 'Банк',
    type: 'text',
    name: 'bank',
    placeholder: 'Введите название банка',
    disabled: false,
  },
  {
    label: 'Корр. счет',
    type: 'number',
    name: 'corresponding_account',
    placeholder: 'Введите номер счета',
    disabled: false,
  },
  {
    label: 'Идентификатор производства',
    type: 'text',
    name: 'external_id',
    placeholder: 'Введите id производства',
    disabled: false,
  },
];
